@if (loading()) {
	<div class="chemical-usage-log-row__loading">
		<tui-icon icon="@tui.loader" />
	</div>
} @else {
	<div class="chemical-usage-log-row__information">
		<p class="chemical-usage-log-row__information-title line-clamp-1">
			{{ usageLog().location }}
		</p>

		<p
			class="chemical-usage-log-row__information-subtitle line-clamp-2"
			[innerHtml]="
				'chemical.usage-log.applied-date'
					| transloco
						: {
								date:
									appliedAtDate()
									| date: 'MMMM d, yyyy hh:mm aa',
						  }
			"
		></p>

		<small
			class="chemical-usage-log-row__information-small line-clamp-1"
			[tuiHint]="chemicalTooltip()"
			tuiHintAppearance="dark"
		>
			{{ chemical()?.name ?? ('chemical.unknown' | transloco) }}
		</small>
	</div>

	<div class="chemical-usage-log-row__actions">
		<ctx-chemical-rei-badge [reiDate]="reiDate()" />

		@if (readOnly() && menuItems().length) {
			<button
				size="m"
				tuiIconButton
				appearance="ghost"
				[tuiHint]="'chemical.usage-log.view-details' | transloco"
				(click)="onViewDetails()"
			>
				<tui-icon icon="@tui.info" />
			</button>
		} @else if (menuItems().length) {
			@if ('mobile' | isDevice) {
				<button
					size="m"
					tuiIconButton
					appearance="ghost"
					(click)="onMenuOpen()"
				>
					<tui-icon icon="@tui.ellipsis" />
				</button>
			} @else {
				<button
					size="m"
					tuiIconButton
					appearance="ghost"
					[tuiDropdown]="usageLogDropdown"
					[(tuiDropdownOpen)]="menuOpen"
				>
					<tui-icon icon="@tui.ellipsis" />
				</button>
			}
		}
	</div>
}

<ng-template #usageLogDropdown>
	<ctx-detail-menu-dropdown [menuItems]="menuItems()" />
</ng-template>
